import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"

export class CarouselDotsProps extends BaseProps {
  count: Number = 0;
  selectedDotIndex: Number = 0;
  onClick: Function;
}

export const CarouselDots = (props: CarouselDotsProps) => {
  const dotsProps = [];

  for (let i = 0; i < props.count; i++) {
    const dot = {
      onClick: () => props.onClick(i),
      className: classNames(styles.dot, {[styles.dot_active]: props.selectedDotIndex === i})
    };

    dotsProps.push(dot);
  }
  return (
    <div className={classNames(styles.dots_container)}>
      {
        dotsProps.map((dot, index) => <div {...dot} key={index}/>
        )
      }
    </div>
  )
};
